(function ($) {
    var ms = $.mobiscroll,
        presets = ms.presets.scroller;

    presets.treelist = presets.list;

    ms.presetShort('list');
    ms.presetShort('treelist');

})(jQuery);


// WEBPACK FOOTER //
// ./src/mobiscroll/js/mobiscroll.treelist.js